import { ScimProvisioningStatus, ScimConfigurationResponse } from '@mews-commander/data-access';
import { StatusTag } from '../components/StatusTag';

export const ScimStatusTag = ({ provisioningStatus }: ScimConfigurationResponse) => {
    const enabled = provisioningStatus === ScimProvisioningStatus.Active;

    return <StatusTag isEnabled={enabled} />;
};
